//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionReadAloud(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.57 7.57L15 8.89C15.3158 9.54857 15.4797 10.2696 15.4797 11C15.4797 11.7304 15.3158 12.4514 15 13.11L16.57 14.43C17.1663 13.3852 17.4799 12.203 17.4799 11C17.4799 9.79701 17.1663 8.61481 16.57 7.57ZM19.48 11C19.4808 12.6732 19.0094 14.3127 18.12 15.73L19.67 17C20.838 15.2169 21.4602 13.1316 21.4602 11C21.4602 8.86839 20.838 6.78312 19.67 5L18.12 6.3C19.004 7.70862 19.4752 9.33697 19.48 11Z" fill="currentColor" /><path d="M11 20L6 16H2V14H7L11 17V6L7 9H4V12H2V7H6L11 3H13V20H11Z" fill="currentColor" /></svg>;
}
export default IconActionReadAloud;